import { render, staticRenderFns } from "./LobAddressSuggestionModal.vue?vue&type=template&id=202134c2&scoped=true"
import script from "./LobAddressSuggestionModal.vue?vue&type=script&lang=ts"
export * from "./LobAddressSuggestionModal.vue?vue&type=script&lang=ts"
import style0 from "./LobAddressSuggestionModal.vue?vue&type=style&index=0&id=202134c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202134c2",
  null
  
)

export default component.exports